import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import { Stack } from "@mui/material";
import { useResultCommentCreate } from "../../data/useResultCommentCreate";

interface Props {
  captureId: number;
  open: boolean;
  onClose: () => void;
  onSuccess: (successMessage: string) => void;
  onError: (errorMessage: string) => void;
}

export function NewCommentDialog(props: Props) {
  const { t } = useTranslation();
  const { captureId, open, onClose, onSuccess, onError } = props;

  const [commentText, setCommentText] = useState("");

  const commentCreate = useResultCommentCreate(captureId, {
    onSuccess: handleCreateCommentSuccess,
    onError: handleCreateCommentError,
  });

  function handleCreateCommentSuccess() {
    setCommentText("");
    onSuccess(t("common.commentCreateSuccess"));
    onClose();
  }

  function handleCreateCommentCancel() {
    setCommentText("");
    onClose();
  }

  function handleCreateCommentError() {
    onError(t("common.dataCreateError", { val: t("common.comment") }));
  }

  function handleCreateCommentClick() {
    commentCreate.mutate(commentText);
  }

  function handleCommentTextChange(e: React.ChangeEvent<HTMLTextAreaElement>) {
    const text = e.target.value;
    setCommentText(text);
  }

  const header = <>{t("common.newComment")}</>;

  const footer = (
    <>
      <Stack direction="row" justifyContent="flex-end">
        <Button variant="contained" onClick={handleCreateCommentClick} disabled={!commentText}>
          {t("common.addComment")}
        </Button>
        <Button variant="contained" color="secondary" onClick={handleCreateCommentCancel}>
          {t("common.cancel")}
        </Button>
      </Stack>
    </>
  );

  return (
    <Dialog
      header={header}
      visible={open}
      onHide={handleCreateCommentCancel}
      footer={footer}
      breakpoints={{ "1100px": "40vw", "900px": "60vw", "600px": "90vw" }}
      style={{ width: "30vw" }}
    >
      <Stack direction="row" p={1} spacing={4}>
        <InputTextarea value={commentText} onChange={handleCommentTextChange} autoResize style={{ width: "100%" }} />
      </Stack>
    </Dialog>
  );
}
